import { render, staticRenderFns } from "./legal-order-details.vue?vue&type=template&id=af5f8366&scoped=true&"
import script from "./legal-order-details.vue?vue&type=script&lang=js&"
export * from "./legal-order-details.vue?vue&type=script&lang=js&"
import style0 from "./legal-order-details.vue?vue&type=style&index=0&id=af5f8366&prod&lang=less&"
import style1 from "./legal-order-details.vue?vue&type=style&index=1&id=af5f8366&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5f8366",
  null
  
)

export default component.exports